import request from '@/utils/request'

// 查询客户月账单数据
export function findAgentMonthlyBills(params) {
  return request({
    url: `/agent_monthly_bills`,
    method: 'get',
    params: params
  })
}

// 导出客户月账单数据
export function exportAgentMonthlyBills(data) {
  return request({
    url: `/agent_monthly_bills/export`,
    method: 'post',
    data
  })
}

// 查询客户月账单详情
export function findAgentMonthlyBill(id) {
  return request({
    url: `/agent_monthly_bills/${id}`,
    method: 'get'
  })
}

// 查询客户月账单采购账单列表
export function findPurchaseBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/purchase_bills`,
    method: 'get',
    params: params
  })
}

// 查询客户月账单激活账单列表
export function findActiveBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/active_bills`,
    method: 'get',
    params: params
  })
}

// 查询客户月账单续期账单列表
export function findRenewBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/renew_bills`,
    method: 'get',
    params: params
  })
}

// 查询客户月账单订购账单列表
export function findSubscribeBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/subscribe_bills`,
    method: 'get',
    params: params
  })
}

// 查询客户月账单流量使用账单列表
export function findCardUseBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/product_usage_orders`,
    method: 'get',
    params: params
  })
}

// 查询客户月账单停机保号账单列表
export function findStopBills(id, params) {
  return request({
    url: `/agent_monthly_bills/${id}/product_stop_orders`,
    method: 'get',
    params: params
  })
}
